import { TechniqueFull } from '@omniafishing/core';
import _ from 'lodash';

export function stylesBySpecies(styles: TechniqueFull[], speciesNames: string[]) {
  return styles.filter((style) => _.intersection(style.species, speciesNames).length);
}
